import React from 'react'
import { BsCheck } from 'react-icons/bs';
import Select from "react-select";
import { customStyles } from '../../util/FormatUtil';

const CustomSelect = (props) => {

    // console.log('props in CustomSelect', props)


    return (
        <div className="form-group row">
                <div className={props.fromFilterPage ? "col-10 col-md-8 pl-0" : props.resultSelect ? "col-12 col-md-4" : "col-12 col-md-4"} data-toggle={"tooltip"} data-placement={"top"} title={props.tooltip}>
                    <label htmlFor={props.label} style={{ fontSize: "0.8em" }} className={"pt-1 font-weight-bold"}>
                    {props.label}
                    </label>
                </div>
                <div className={props.fromFilterPage ? "col-2" : "d-none"}>
                    {props.value ? (<BsCheck className={"float-md-right"} color={"#21212E"} size={20} />) : null}
                </div>
                <div className={props.fromFilterPage ? "col-12 col-md-10 pl-0 pr-1" : props.resultSelect ? "col-12 col-md-8 pl-lg-4 pl-xl-5" : "col-12 col-md-8 pl-md-0 pr-md-1"} id={props.label}>
                    <div className="row">
                    <div className="col-12">
                        <Select
                            styles={props.fromFilterPage && customStyles}
                            isDisabled={props.disabled ? props.disabled : false}
                            isMulti={props.fromFilterPage || props.isMulti ? true : false}
                            isSearchable={true}
                            placeholder={"Select..."}
                            onChange={(e) => {
                                props.handleChange(e)
                            }}
                            className={"state_select"}
                            options={props.options}
                            value={props.value}
                        />
                    </div>
                    </div>
                </div>
            </div>
    )
}

export default CustomSelect